import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TokenStorageService } from 'src/app/util/services/token-storage.service';
import { Languages } from 'src/app/util/settings/languages';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input()
  public isLoggedIn: boolean;
  breakpoint: number;

  languages = [
    {value: Languages.SPANISH, viewValue: 'Español'},
    {value: Languages.PORTUGUESE, viewValue: 'Português'},
    // {value: Languages.ENGLISH, viewValue: 'English'},
  ];

  selected = this.languages[0].value;

  useLanguage() {
    this.translate.use(this.selected);
  }

  constructor(private translate: TranslateService, private tokenStorageService: TokenStorageService) {
    translate.setDefaultLang(this.selected);
  }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 6;
  }

  logout() {
    this.tokenStorageService.signOut();
    window.location.reload();
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 6;
  }

}
